const NGS = ({ ...props }) => (
  <svg
    version="1.1"
    viewBox="0 0 2048 2048"
    width="1280"
    height="1280"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      transform="translate(996,24)"
      d="m0 0h57l40 2 37 3 47 6 40 7 41 9 32 8 43 13 35 12 31 12 26 11 26 12 21 10 19 10 24 13 24 14 19 12 25 16 18 13 14 10 16 12 28 22 30 26 10 9 13 12 10 10 2 1v2l4 2 8 8 7 8 13 13 7 8 12 13 9 11 13 15 22 28 12 16 24 34 21 33 9 15 16 28 12 23 10 19 13 28 14 32 14 37 8 22 13 42 11 42 8 36 7 38 6 43 4 41 2 33v90l-2 33-3 33-6 44-7 40-9 41-10 38-11 36-12 35-16 41-13 29-14 29-14 28-13 23-14 24-14 22-18 27-13 18-10 14-22 28-9 11-12 14-9 10-7 8-9 10-8 8-7 8-24 24h-2l-1 3-8 7-8 8-8 7-14 12-10 9-14 11-15 12-17 13-17 12-14 10-15 10-17 11-21 13-23 13-18 10-33 17-36 17-29 12-37 14-36 12-34 10-44 11-38 8-51 8-34 4-40 3-19 1h-84l-45-3-46-5-38-6-37-7-42-10-36-10-52-17-31-12-31-13-28-13-44-22-24-14-18-10-44-28-18-13-17-12-18-14-15-12-11-9-14-12-10-9-11-9-11-11-8-7-35-35-7-8-7-7-9-11-11-12-9-11-13-16-11-14-15-20-13-19-10-14-14-22-13-21-16-28-13-24-19-38-15-34-13-33-9-24-12-37-11-39-8-32-9-45-7-45-4-36-3-39-1-23v-69l2-38 3-34 6-46 7-40 8-37 8-32 10-34 12-37 12-32 12-29 16-35 8-17 20-38 14-24 10-17 11-17 18-27 13-18 10-14 12-15 7-9 11-14 10-11 9-11 11-12 7-8 13-13 7-8 18-18 8-7 13-13 8-7 13-11 15-13 16-13 16-12 17-13 20-14 13-9 25-16 19-12 23-13 18-10 33-17 30-14 25-11 31-12 30-11 38-12 45-12 41-9 32-6 42-6 27-3 42-3z"
      fill="#FD6B00"
    />
    <path
      transform="translate(768,343)"
      d="m0 0h557l16 2 15 5 13 7 10 8 9 9 7 11 7 16 3 16 1 56v899l1 80 44 1 5 3 5 6 1 20v81h64l7 2 6 7 1 24v90l-2 10-6 7-2 1h-1013l-6-5-3-7-1-33v-24l1-62 4-6 5-3h68v-55l1-47 6-7 5-2h45l-1-462v-460l1-110 2-14 6-16 8-14 7-9 8-7 14-9 12-5 13-3z"
      fill="#FD6B00"
    />
    <path
      transform="translate(768,343)"
      d="m0 0h557l16 2 15 5 13 7 10 8 9 9 7 11 7 16 3 16 1 56v899l1 80 44 1 5 3 5 6 1 20v81h64l7 2 6 7 1 24v90l-2 10-6 7-2 1h-1013l-6-5-3-7-1-33v-24l1-62 4-6 5-3h68v-55l1-47 6-7 5-2h45l-1-462v-460l1-110 2-14 6-16 8-14 7-9 8-7 14-9 12-5 13-3zm196 30-239 1-16 2-14 7-10 9-6 9-4 9-2 11v685l5 10 9 10 9 11 9 10 9 11 9 10 9 11 13 15 12 14 11 13 12 14 9 11 12 14 11 13 7 8 1 1h408l11-12 9-11 8-9 9-11 10-11 9-11 24-28 9-11 13-15 9-11 9-10 9-11 12-14 5-7v-693l-4-13-6-10-5-6-13-9-12-4-10-1-293-1z"
      fill="#FEFDFD"
    />
    <path
      transform="translate(1017,756)"
      d="m0 0h12l24 2 18 3 26 7 20 8 16 8 14 8 13 9 14 11 7 7 8 7v2l3 1 7 8 11 14 10 15 12 22 8 20 5 15 6 28 2 17v37l-3 21-5 22-7 21-9 20-8 15-10 15-10 13-14 15-12 12-14 11-13 9-19 11-19 9-24 8-16 4-27 4h-39l-31-5-24-7-15-6-23-11-19-12-14-11-11-10-8-7v-2h-2l-7-8-8-10-12-17-12-21-9-21-7-21-5-24-3-25v-19l2-21 5-26 6-20 7-18 8-16 8-14 12-17 9-11 8-8 6-7 8-7 16-13 18-12 23-12 24-9 18-5 30-5z"
      fill="#FD6B00"
    />
    <path
      transform="translate(539,1594)"
      d="m0 0h969l1 2v77l-1 1h-967l-2-1-1-66v-12z"
      fill="#FD6B00"
    />
    <path
      transform="translate(813,500)"
      d="m0 0h422l9 2 4 5 1 2 1 19v29l-1 92-3 6-4 3-5 1h-426l-8-3-3-3-1-3-1-14v-126l3-5 5-4z"
      fill="#FD6B00"
    />
    <path
      transform="translate(618,1483)"
      d="m0 0h812l1 1v23l-1 56-1 1h-691l-121-1v-79z"
      fill="#FD6B00"
    />
    <path
      transform="translate(673,1158)"
      d="m0 0 5 4 9 11 9 10 9 11 10 11 9 11 12 14 9 11 10 11 9 11 13 15 9 11 10 11 7 8 4 3 3 1 88 1 1 1v34l-1 105h-222l-3-3z"
      fill="#FD6B00"
    />
    <path
      transform="translate(1374,1158)"
      d="m0 0h1v50l-1 245h-222l-3-1v-139l90-1 5-3 7-7 9-11 48-56 9-11 9-10 9-11 12-14 9-11 10-11 7-8z"
      fill="#FD6B00"
    />
    <path
      transform="translate(1017,756)"
      d="m0 0h12l24 2 18 3 26 7 20 8 16 8 14 8 13 9 14 11 7 7 8 7v2l3 1 7 8 11 14 10 15 12 22 8 20 5 15 6 28 2 17v37l-3 21-5 22-7 21-9 20-8 15-10 15-10 13-14 15-12 12-14 11-13 9-19 11-19 9-24 8-16 4-27 4h-39l-31-5-24-7-15-6-23-11-19-12-14-11-11-10-8-7v-2h-2l-7-8-8-10-12-17-12-21-9-21-7-21-5-24-3-25v-19l2-21 5-26 6-20 7-18 8-16 8-14 12-17 9-11 8-8 6-7 8-7 16-13 18-12 23-12 24-9 18-5 30-5zm-7 31-22 3-21 5-20 7-16 8-16 9-16 12-10 9-9 8-7 8-13 17-11 18-10 21-7 21-5 23-2 18v21l3 25 6 25 7 19 8 17 10 16 13 17 12 13 9 9 20 15 15 9 16 8 15 6 21 6 25 4h37l25-4 22-6 17-7 16-8 18-11 13-11 8-7 12-12v-2h2l10-13 10-15 9-17 8-20 6-21 4-24 1-15v-13l-2-19-5-24-5-17-9-21-10-18-14-19-15-16-8-8-14-11-14-9-14-8-18-8-18-6-23-5-16-2z"
      fill="#FEFDFD"
    />
    <path
      transform="translate(1023,838)"
      d="m0 0 6 1 8 6 11 14 13 18 10 15 13 21 11 20 10 23 9 27 5 24 1 8v28l-3 17-5 15-8 16-8 10-8 9-14 10-17 8-15 4-6 1h-25l-17-4-17-7-12-8-12-11-9-12-8-15-5-15-3-15-1-8v-15l4-27 6-23 10-26 11-23 12-21 20-30 14-19 9-11 6-4z"
      fill="#FEFDFD"
    />
    <path
      transform="translate(812,469)"
      d="m0 0h420l16 2 10 4 9 7 7 8 5 12 1 6 1 41v91l-2 17-7 14-8 9-10 6-11 3-71 1h-356l-13-1-11-4-9-6-8-8-6-12-2-12v-137l3-12 6-11 6-7 11-7 9-3zm1 31-9 2-5 5-1 3v126l1 14 3 5 5 3 4 1h426l6-2 5-5 1-3 1-92v-29l-1-19-4-6-3-2-7-1z"
      fill="#FEFDFD"
    />
    <path
      transform="translate(1023,880)"
      d="m0 0 4 2 11 16 13 20 12 21 11 23 7 19 6 22 2 12 1 19-2 15-4 14-6 11-7 9-10 9-12 6-9 3-6 1h-21l-14-4-10-5-10-8-7-8-7-12-5-16-1-5v-30l4-21 8-24 11-25 13-23 12-19 10-14z"
      fill="#FD6B00"
    />
    <path
      transform="translate(1040,1313)"
      d="m0 0h77l1 1-1 139h-74l-4-1v-138z"
      fill="#FD6B00"
    />
    <path
      transform="translate(930,1313)"
      d="m0 0h78v140h-76l-2-1z"
      fill="#FD6B00"
    />
  </svg>
);
export default NGS;
